var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDisposal = function SvgDisposal(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "disposal_svg__disposal",
    x: 0,
    y: 0,
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "#disposal_svg__disposal .disposal_svg__st2{fill:#59a848;stroke:#dd8390;stroke-width:45.3081;stroke-miterlimit:10}")), /*#__PURE__*/React.createElement("path", {
    d: "M35.4 1000h659.1l5.9-831.5L801.6 2.1 169.9 0C53.6-.4 35.4 97.8 35.4 226.9z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.6 270.5H700.3V133.1C700.3 60.1 759.5 1 832.5 1s132.1 59.2 132.1 132.1z",
    style: {
      fill: "#8ca4af"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M552.1 497.8H183.3M432.6 623.5H183.3",
    className: "disposal_svg__st2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDisposal);
export default ForwardRef;